module.exports = __webpack_public_path__ + "img/round-person.ea0f4772.svg";